/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
var ID = {
  ERROR_BOUNDARY_ALERT_ID: 'error-boundary-alert',
  IEG_PAGE_NOT_AVAILABLE_ID: 'error-ieg-page-not-available'
};
/* eslint-disable import/prefer-default-export */

export { ID };